export default "__VITE_ASSET__BSNVAdgO__"